export default __webpack_public_path__ + "d0da70a0422c9a6bbb9245d1aff23bd8.png";